import {createAction, props} from "@ngrx/store";
import {Serializers} from "../../interfaces/serializer";
import {ActionCreator, TypedAction} from '@ngrx/store/src/models';
import {DataSourceDimension} from '../../interfaces/dimensions';

export const loadDataSourceDimensions: ActionCreator<'[DATA_SOURCES_DIMENSIONS] Load', () => TypedAction<'[DATA_SOURCES_DIMENSIONS] Load'>> = createAction('[DATA_SOURCES_DIMENSIONS] Load');

export const loadDataSourceDimensionsSuccess: ActionCreator<
  '[DATA_SOURCES_DIMENSIONS] Load success',
  (props: { dimensions: Serializers<DataSourceDimension> }) => TypedAction<'[DATA_SOURCES_DIMENSIONS] Load success'> & { dimensions: Serializers<DataSourceDimension> }
> = createAction(
  '[DATA_SOURCES_DIMENSIONS] Load success',
  props<{ dimensions: Serializers<DataSourceDimension> }>()
);
